import { useState } from 'react';

import { useClientSideSearch } from '@/hooks/useClientSideSearch';

import { Account } from '@/types/planning';

import { LOCALE } from '@/utils/i18n';

type UseSearchProps = {
  accounts: Account[];
  locale: LOCALE;
};

export const useSearch = ({ accounts, locale }: UseSearchProps) => {
  const [query, setQuery] = useState<string>('');
  const searchableFields = ['name', `riskProfile.title.${locale}`, 'totalValue', 'targetRateOfReturn'];
  const { filteredData } = useClientSideSearch({ data: accounts || [], query, searchableFields });

  return {
    searchQuery: query,
    setQuery,
    filteredData,
  };
};
